import { Directive, ElementRef, Input } from '@angular/core';
import { NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';

export enum DropdownMenuType {
  Base = 'ngbDropdownMenuRef',
  Form = 'ngbDropdownMenuFormRef'
}

@Directive({
  selector: '[dropdownRef]',
  standalone: true
})
export class DropdownRefDirective {
  @Input('dropdownRef') id!: DropdownMenuType;

  constructor(
    public el: ElementRef<HTMLElement>,
    public ngbDropdownMenu: NgbDropdownMenu
  ) {}
}
